{
  "asset_id": "6aab277e-4b16-430f-98c7-566d1d11f341",
  "content_type": "image/png",
  "created_at": "2026-09-06T01:57:51Z",
  "original_filename": "h2j-growth-company.png",
  "project_id": "2e05451c-9ac5-4503-b5ea-624bd8d09e1e",
  "r2_key": "a/v1/2e05451c-9ac5-4503-b5ea-624bd8d09e1e/6aab277e-4b16-430f-98c7-566d1d11f341/h2j-growth-company.png",
  "size": 732975,
  "url": "/__l5e/assets-v1/6aab277e-4b16-430f-98c7-566d1d11f341/h2j-growth-company.png",
  "version": 1
}